import { Recipe } from 'types/recipe';

export const recipes: Array<Omit<Recipe, 'ingredients'> & { ingredients: string[] }> = [
  {
    name: '🥪 Cheese Sandwich',
    ingredients: ['2dafbf15-966f-49ff-8e14-5b68eb1dd7a5', 'c51c0951-6298-435d-8e5a-92f9417b1bf9'],
    id: 'WOrOP5q6CnYv5s9zs8LA',
  },
  {
    name: '🍗 Chicken Nibbles',
    ingredients: [],
    id: 'd99ed108-19e3-43db-8e51-0161d5a6de93',
  },
  {
    name: '🐔 Chicken Schnitzel ',
    ingredients: [
      '93627fa4-55da-4a7e-a2f1-96e9ea0a0c1a',
      'b2450dd0-cef9-49b1-8ef7-bd45f0edf97f',
      '04fe0f59-a6a1-40f4-b3e8-ba9f609103d0',
      '782ccfbd-391a-4923-965c-00207569a280',
    ],
    id: '9eb538bc-e3ec-43fd-bc28-c14e8a43a8f2',
  },
  {
    name: '🥚 Frittata',
    ingredients: [
      '950a2377-af02-4877-bf4b-fdc69fed1447',
      '0a1f87d2-333b-4b43-97dd-d37bdd04aff8',
      '93627fa4-55da-4a7e-a2f1-96e9ea0a0c1a',
      '782ccfbd-391a-4923-965c-00207569a280',
    ],
    id: '58d806ea-1d0b-43c4-a354-b03f751cc496',
  },
  {
    name: '🥩 Meatloaf',
    ingredients: [],
    id: '3f4995b4-778c-4d45-9be1-2f3c22e8004a',
  },
  {
    name: '⚽ Meatballs',
    ingredients: ['b7ba3647-7f5a-47af-90e2-d7e0de93422b', '811af15c-e37e-47ca-b345-348512fcceb0'],
    id: '33e44d18-24ec-4592-a79c-315602a1588a',
  },
  {
    name: '🍝 Pasta',
    ingredients: [],
    id: '88c7cf55-9c3a-4576-bfa1-c14122f80c20',
  },
  {
    name: '🥗 Salad',
    ingredients: ['63d1be1b-15f4-4e2e-9e3c-9f0280421cca', '317fdc02-ad3c-4e05-87d0-d77144aea36c'],
    id: 'e34dc65b-28a0-4b66-a99e-f537ae397aae',
  },
  {
    name: '🍞 Sandwiches',
    id: 'b56e29b2-82d9-405c-b95f-d643da782b84',
    ingredients: [
      '2dafbf15-966f-49ff-8e14-5b68eb1dd7a5',
      'c51c0951-6298-435d-8e5a-92f9417b1bf9',
      'e880745e-3d0f-4e92-a287-c79be26e745e',
      'b475cb8b-0b31-4922-a4b8-1e67004746fe',
      '1ee26204-9f3a-4a14-b2c9-19835634e490',
      '0d703b12-6357-48f9-a298-a7a1a13423c2',
      '6ac8e775-54ca-4c56-a2b6-ac29a922618d',
      'b7ba3647-7f5a-47af-90e2-d7e0de93422b',
    ],
  },
  {
    name: '🍝 Spaghetti Bolognese',
    ingredients: ['c75b30e1-058e-48aa-a973-5e9ff64f8001', '811af15c-e37e-47ca-b345-348512fcceb0'],
    id: 'b4391b27-2793-4c3e-9ddd-7b8dde4d621f',
  },
  {
    name: '🥡 Takeaways',
    ingredients: [],
    id: '015e612d-39d0-4a67-b418-c682311fd7ea',
  },
  {
    ingredients: [
      '93627fa4-55da-4a7e-a2f1-96e9ea0a0c1a',
      '2b70e615-8afd-40e0-9647-bbddac0de08d',
      '5a06d9d3-efdf-4b41-9cea-baf3cc73dafb',
      'b2450dd0-cef9-49b1-8ef7-bd45f0edf97f',
      '5565d88d-04d5-4991-b727-e6a6d69df6a2',
      'ed40bf7c-40cb-4015-b4a0-620fbea71d8f',
      '651eb640-b057-4275-9d8b-56f1c30a494e',
    ],
    name: '🥒 Vegetables',
    id: 'c2ed0f99-3250-4755-aa5f-7d18c8aa5b9f',
  },
  {
    name: '🥣 Weet-Bix',
    ingredients: [
      '6ac8e775-54ca-4c56-a2b6-ac29a922618d',
      'dfe94941-5f7a-42f7-93a9-9b4247ede351',
      'b27ab940-325b-4a7f-94a2-4f3e48b7a436',
    ],
    id: 'ea99b10c-9111-469c-bbfc-f824367efb9e',
  },
];
